import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DevToolsProvider } from '@ps-gui/ui';
import { FillMode } from '../generators/field-value.generator';

@Component({
  selector: 'ct-extraction-field-group-dev-tools-panel',
  templateUrl: './field-group-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldGroupPanelComponent {
  readonly provider = input.required<DevToolsProvider<FillMode>>();

  protected generate(mode: FillMode): void {
    this.provider().apply(mode);
  }
}
